const MONDELEZ_ID = 81
const NTN_ROLAMENTOS_ID = 64
const MOSAIC_FERTILIZANTES_ID = 109

export { MONDELEZ_ID, NTN_ROLAMENTOS_ID, MOSAIC_FERTILIZANTES_ID }
